@import '../../theme/global.scss';

:host {
  display: inline-flex;
  @include set-font;

  .sr-only {
    @include sr-only;
  }
}

.snap-link {
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  font-weight: 700;
  padding: 12px 0;
  text-decoration: none;
  vertical-align: middle;

  @media (min-width: map-get($breakpoints, 'md')) {
    padding: 0;
  }

  > * {
    display: inline-flex;
  }

  &:hover {
    .snap-link-text-container {
      align-items: center;
      display: flex;
      height: 100%;
      position: relative;

      &::before {
        background-color: $blue-800;
        bottom: 2px;
        content: '';
        height: 1px;
        position: absolute;
        width: 100%;

        @media (min-width: map-get($breakpoints, 'md')) {
          bottom: 2px;
        }
      }
    }
  }

  &:focus-visible {
    background-color: $base-light;
    border-radius: 2px;
    outline: none;
  }

  &--semibold {
    font-weight: 600;
  }

  &--medium {
    font-weight: 500;
  }

  &--xs {
    font-size: 0.75rem;
    line-height: 1rem;
    padding: 16px 0;

    @media (min-width: map-get($breakpoints, 'md')) {
      padding: 4px 0;
    }

    &:hover {
      .snap-link-text-container::before {
        bottom: 1px;

        @media (min-width: map-get($breakpoints, 'md')) {
          bottom: 1px;
        }
      }
    }
  }

  &--sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 14px 0;

    @media (min-width: map-get($breakpoints, 'md')) {
      padding: 2px 0;
    }

    &:hover {
      .snap-link-text-container::before {
        bottom: 2px;

        @media (min-width: map-get($breakpoints, 'md')) {
          bottom: 2px;
        }
      }
    }
  }

  &--base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  &--default {
    color: $blue-700;

    &:hover,
    &:active{
      color: $blue-800;
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $blue-500;
    }
  }

  &--danger {
    color: $red-700;

    &:hover,
    &:active{
      color: $red-800;

      .snap-link-text-container::before {
        background-color: $red-800;
      }
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $red-500;
    }
  }

  &--warning {
    color: $yellow-700;

    &:hover,
    &:active {
      color: $yellow-800;

      .snap-link-text-container::before {
        background-color: $yellow-800;
      }
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $yellow-500;
    }
  }

  &--success {
    color: $green-700;

    &:hover,
    &:active {
      color: $green-800;

      .snap-link-text-container::before {
        background-color: $green-800;
      }
    }

    &:focus-visible {
      box-shadow: 0 0 0 1px #FFF, 0 0 0 2px $green-500;
    }
  }

  &.disabled {
    color: $gray-400;
    cursor: initial;
    pointer-events: none;
  }

  &--with-icon {
    text-decoration: none;

    &.snap-link--icon-left {
      .snap-icon {
        margin-right: 4px;
      }
    }

    &.snap-link--icon-right {
      .snap-icon {
        margin-left: 4px;
      }
    }
  }
}
